export const graphqlEndpoint = process.env.GRAPHQL_ENDPOINT ?? 'https://square.smartgates.net/v1/graphql';

export const clientGraphqlEndpoint =
  process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT ?? 'https://square.smartgates.net/v1/graphql';

export const apiEndpoint = process.env.NEXT_PUBLIC_API_ENDPOINT ?? '/merchant-api/v1';
